<div class="doc-page">
	<div class="sec-state portal-error" *ngIf="error">{{ error }}</div>
	<div class="doc-frame-wrap" *ngIf="!loading && !error && src">
		<iframe
			class="doc-frame"
			[class.doc-frame-ready]="!frameLoading"
			[src]="src"
			title="{{ heading }}"
			(load)="frameLoading = false"></iframe>
	</div>
</div>
